import SetupGoogleAnalytics from "../../setup/components/setup/SetupGoogleAnalytics.client";

export default function GoogleAnalytics() {
    return (
        <>
            <SetupGoogleAnalytics />;
        </>
    )
}